import { render } from "./DoctorAppointmentsList.vue?vue&type=template&id=12bec55f&scoped=true"
import script from "./DoctorAppointmentsList.vue?vue&type=script&lang=js"
export * from "./DoctorAppointmentsList.vue?vue&type=script&lang=js"

import "./DoctorAppointmentsList.vue?vue&type=style&index=0&id=12bec55f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bec55f"]])

export default __exports__